/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './search-pagination.stache';
import can from 'can';
import $ from 'jquery';
import appContext from 'scripts/app-context';
import { cludoConfig } from 'scripts/services/cludo-search';

const limit = cludoConfig.perPage;
const maxPagesPerView = 10;

Component.extend({
    tag: 'search-pagination',
    template: template,
    viewModel: {
        limit,
        maxPagesPerView,
        define: {
            nextPage: {
                Type: can.Map,
                Value: can.Map,
            },
            previousPage: {
                Type: can.Map,
                Value: can.Map,
            },
            getPages: {
                get() {
                    let paginationSettings = this.attr('paginationSettings');

                    let startIndex = parseInt(
                            paginationSettings.attr('startIndex'),
                        ),
                        total = parseInt(paginationSettings.attr('total')),
                        pages = [];

                    if (startIndex == null || total == null) {
                        console.warn('startIndex or total is undefined');
                        return;
                    }

                    this.attr('previousPage', null);
                    this.attr('nextPage', null);

                    const pagination = this.getPagination();
                    for (let i = 0; i < pagination.length; i++) {
                        let pageNumber = pagination[i];

                        if (pageNumber === 'd') {
                            pages.push({
                                isEllipsis: true,
                            });
                        } else {
                            let pageOffset = (pageNumber - 1) * limit + 1;
                            let page = {
                                value: pageNumber,
                                startIndex: pageOffset,
                                isActive: pageOffset === startIndex,
                            };
                            pages.push(page);

                            if (pageOffset + Number(limit) === startIndex) {
                                this.attr('previousPage', page);
                            }
                            if (pageOffset - Number(limit) === startIndex) {
                                this.attr('nextPage', page);
                            }
                        }
                    }

                    return pages;
                },
            },
        },
        changeStartIndex: function(event, startIndex) {
            event.preventDefault();
            if ($(event.target).hasClass('s-page--active')) {
                return;
            }
            appContext.model.dispatch('page-changed', [startIndex]);
        },
        getPagination() {
            let paginationSettings = this.attr('paginationSettings');

            const totalPages = Math.ceil(
                parseInt(paginationSettings.attr('total')) / limit,
            );
            const page = Math.ceil(
                parseInt(paginationSettings.attr('startIndex') || 1) / limit,
            );
            const numbers = [];

            if (totalPages <= maxPagesPerView) {
                // 1 2 3 4 5
                for (let i = 1; i <= totalPages; i++) {
                    numbers.push(i);
                }
            } else {
                numbers.push(1);

                if (page <= maxPagesPerView - 2) {
                    // 2 3 4 ..
                    for (let i = 2; i < maxPagesPerView; i++) {
                        numbers.push(i);
                    }
                    numbers.push('d');
                } else if (page >= totalPages - (maxPagesPerView - 3)) {
                    // .. 10 11 12 13
                    const startNumber = totalPages - (maxPagesPerView - 2);
                    numbers.push('d');
                    for (let i = startNumber; i < totalPages; i++) {
                        numbers.push(i);
                    }
                } else {
                    const pagesCount =
                        maxPagesPerView - 4 + ((maxPagesPerView - 3) % 2);
                    const medianIndex = Math.ceil(pagesCount / 2);
                    numbers.push('d');
                    for (let i = 0; i < pagesCount; i++) {
                        numbers.push(page + (i - medianIndex + 1));
                    }
                    numbers.push('d');
                }

                numbers.push(totalPages);
            }

            return numbers;
        },
    },
});
